/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputModule} from '../../shared/input/input.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {PartNumberChangesAdditionalInputModule} from '../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';
import {PartNumberChangesAiSolutionComponent} from './part-number-changes-ai-solution.component';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [PartNumberChangesAiSolutionComponent],
    imports: [
        CommonModule,
        InputModule,
        PipesModule,
        PartNumberChangesAdditionalInputModule,
        TooltipModule
    ],
    exports: [PartNumberChangesAiSolutionComponent]
})
export class PartNumberChangesAiSolutionModule {
}
